//
// Wheel Controller
//
// Handles wheel feature mechanics and animations
// ----------------------------

(function () {
  class WheelController {
    constructor() {
      this._active = false;
      this._currentWheelData = null;
      this._currentFeatureSpinsData = null;
      this._wheelSpinning = false;
      this._currentSpinIndex = 0;
      
      // Set up message bus subscriptions
      messageBus.subscribe('spinner:GameConfigEvent', this.onGameConfigEvent.bind(this));
    }

    initialise(json) {
      // Controller initialization
      console.log('WheelController: Initialised');
      
      // TODO: Set up UI elements and initial state
      // - Link to wheel display
      // - Set up wheel sections
      // - Initialize animations
    }

    processWheel(wheelPart, featureSpinsPart) {
      // Main entry point for wheel processing
      console.log('WheelController: Processing wheel', wheelPart);
      
      // Add prominent feature trigger console output with gold color for wheel
      const featureColor = '#FFD700'; // Gold color for wheel/gold pig
      console.log(`%c🎉 FEATURE TRIGGERED! 🎉`, `color: ${featureColor}; font-weight: bold; font-size: 16px; background: white; padding: 4px; text-shadow: 2px 2px 4px rgba(0,0,0,0.5);`);
      console.log(`%cFEATURE TYPE: WHEEL`, `color: ${featureColor}; font-weight: bold; font-size: 14px; background: white; padding: 2px;`);
      
      // Store wheel data
      this._currentWheelData = wheelPart;
      this._currentFeatureSpinsData = featureSpinsPart;
      this._active = true;
      
      // Start wheel sequence
      this.startWheelFeature();
    }

    startWheelFeature() {
      // Initialize wheel feature display and animations
      console.log('WheelController: Starting wheel feature');
      
      // TODO: Implement wheel start sequence
      // - Show wheel intro popup
      // - Display wheel with current state
      // - Start wheel spins
      
      this.processWheelSpins();
    }

    processWheelSpins() {
      // Process each wheel spin
      const spinIndexes = this._currentWheelData.spinIndexes;
      console.log('WheelController: Processing wheel spins', spinIndexes);
      
      // TODO: Implement wheel spin animations
      // - Animate wheel spinning
      // - Land on specified indexes
      // - Show wheel section contents
      
      // Process each spin result
      for (let i = 0; i < spinIndexes.length; i++) {
        this.processWheelSpin(spinIndexes[i]);
      }
      
      // Handle cash wins
      this.processCashWins();
      
      // Handle feature delivery if applicable
      if (this._currentWheelData.didDeliverFeatures && this._currentFeatureSpinsData) {
        this.handleFeatureDelivery();
      } else {
        this.endWheelFeature();
      }
    }

    processWheelSpin(spinIndex) {
      // Process individual wheel spin result
      console.log('WheelController: Processing wheel spin index', spinIndex);
      
      const wheelSection = this.getWheelSectionByIndex(spinIndex);
      if (wheelSection) {
        this.processWheelSection(spinIndex, wheelSection);
      }
    }

    processCashWins() {
      // Handle cash prizes from wheel
      const winAmount = this._currentWheelData.winAmount;
      console.log('WheelController: Processing cash wins', winAmount);
      
      // TODO: Implement cash win processing
      // - Add to win meter
      // - Play win animations
      // - Update UI
    }

    handleFeatureDelivery() {
      // Coordinate with feature controllers when wheel delivers features
      console.log('WheelController: Handling feature delivery', this._currentFeatureSpinsData);
    }

    processWheelSection(sectionIndex, wheelSection) {
      // Process individual wheel section
      console.log('WheelController: Processing wheel section', sectionIndex, wheelSection);
      
      // Handle different section types
      if (wheelSection.cash > 0) {
        this.handleCashSection(wheelSection);
      }
      
      if (wheelSection.red || wheelSection.blue || wheelSection.green) {
        this.handleFeatureSection(wheelSection);
      }
    }

    handleCashSection(wheelSection) {
      // Handle cash prize sections
      console.log('WheelController: Handling cash section', wheelSection);
      
      // TODO: Implement cash section handling
      // - Award cash prize
      // - Mark section as expended if applicable
      // - Convert to collect space
    }

    handleFeatureSection(wheelSection) {
      // Handle feature pig sections
      console.log('WheelController: Handling feature section', wheelSection);
      
      // TODO: Implement feature section handling
      // - Trigger appropriate feature based on pig colors
      // - Handle combinations (red + blue, etc.)
    }

    getWheelSectionByIndex(index) {
      // Get wheel section data by index
      if (!this._currentWheelData || 
          !this._currentWheelData.finalWheel ||
          !this._currentWheelData.finalWheel.wheelSections) {
        return null;
      }
      
      return this._currentWheelData.finalWheel.wheelSections[index];
    }

    endWheelFeature() {
      // End the wheel feature
      console.log('WheelController: Ending wheel feature');
      
      // TODO: Implement wheel end sequence
      // - Show wheel outro if needed
      // - Return to base game
      
      this.reset();
    }

    reset() {
      // Reset wheel controller state
      this._active = false;
      this._currentWheelData = null;
      this._currentFeatureSpinsData = null;
      this._wheelSpinning = false;
      this._currentSpinIndex = 0;
    }

    isActive() {
      return this._active;
    }

    onGameConfigEvent(task) {
      // Handle game configuration event
      console.log('WheelController: Game config event received');
      
      // TODO: Process configuration data
      // - Update wheel section configurations
      // - Set up pig progression values
    }
  }

  // Register controller with resource manager
  resourceManager.registerController('wheelController', function() {
    return new WheelController();
  });
})();